import { useState, useEffect } from 'react';
import { InMemoryCache } from '@apollo/client';
import type { ApolloClient } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import { Toaster } from 'sonner';
import { createApolloClient, restoreCache } from '@scio3/graphql-client';
import { AuthProvider } from '@/contexts/AuthProvider';
import { AppRouter } from '@/routes';
import { getTokenString } from '@/lib/firebase';

export function App() {
  const [apolloClient, setApolloClient] = useState<ApolloClient | null>(null);

  useEffect(() => {
    async function init() {
      const cache = new InMemoryCache();
      await restoreCache(cache);
      const client = createApolloClient({
        getToken: getTokenString,
        graphqlUrl: import.meta.env.VITE_GRAPHQL_URL,
        cache,
      });
      setApolloClient(client);
    }
    init();
  }, []);

  if (!apolloClient) return null;

  return (
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors closeButton style={{ zIndex: 9999 }} />
      </AuthProvider>
    </ApolloProvider>
  );
}
